<template>
    <div class="py-3 px-5" style="background-color: #f5f5f5;height: 98.3vh;">
        <div class="col-12 text-start mx-auto">
            <img src="../../../public/img/logo-white.png" style="width: 100px;cursor: pointer;" alt="" @click="router.push({name:'home'})">
        </div>
        <div class="col-md-5 col-sm-9 col-11 mx-auto mt-5 pt-5">
            <div class="px-sm-5 my-5">
                <div class="px-sm-5 px-4">
                    <h4 class="text-center">Signup</h4>
                    <div class="row my-3 text-end">
                        <input type="text" name="" id="" class="w-100 py-3" v-model="first_name" placeholder="first name">
                        <input type="text" name="" id="" class="w-100 mt-3 py-3" v-model="last_name" placeholder="last name">
                        <input type="text" name="" id="" class="w-100 mt-3 py-3" v-model="phone" placeholder="phoe number">
                        <input type="password" name="" id="" class="w-100 mt-3 py-3" v-model="password" placeholder="password">
                        <button class="btn-blue mt-4 px-5 fs-6" @click="login()">Signup</button>
                        <a href="../sign-in" class="mt-4 text-center fs-6">signin</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import { defineComponent, ref } from 'vue';
import { useRouter } from 'vue-router';

export default defineComponent({

    setup() {
        const phone = ref()
        const password = ref()
        const last_name = ref()
        const first_name = ref()
        const router = useRouter()
        
        function login(){
            if (!phone.value || !password.value) {
            alert("please enter phone number or password.");
            return;
            }
            else {
                axios.put('https://api.xaifin.com/user/register',{'name':first_name.value,'family':last_name.value,'phone':phone.value,'password':password.value}).then((res)=>{
                    if (res.status==200) {
                        router.push({'name':'sign-in'})
                    }
                }).catch((error)=>{                    
                    Swal.fire({
                          text: error.response.data.mess,
                          icon: "error"
                        });
                })
            }
        }

        return{
            phone,
            password,
            last_name,
            first_name,
            router,
            login
        }
    }

})
</script>
<style scoped lang="scss">

.card-custom {
    box-shadow: 0px 0px 5px 0px #adadad;
    border: none;
    border-radius: 8px;
    background-color: white;
  }
</style>